import { FC } from "react";
import { useTranslation } from "react-i18next";
import Heading from "@/components/atoms/Heading";
import Text from "@/components/atoms/Text";
import CTA from "@/components/atoms/CTA";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";
import styles from "./styles.module.css";

interface Props {
  onClick: () => void;
}

const EmptySearchContent: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.emptySearchContentRoot}>
      <Heading order={2} styleOrder={2}>
        {t("trade:searchNoHits")}
      </Heading>
      <SVGAsset name="arrow-up-down" />
      <Text>{t("trade:newOrderQuestion")}</Text>
      <CTA onClick={onClick}>{t("orders:newOrder")}</CTA>
    </div>
  );
};

export default EmptySearchContent;
